import PropTypes from "prop-types";

export const CategoryPropType = PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string
});

export const AuthorPropType = PropTypes.shape({
    email: PropTypes.string,
    display_name: PropTypes.string.isRequired,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    slug: PropTypes.string,
    profileImageSrc: PropTypes.string
});

export const PostPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    categories: PropTypes.arrayOf(CategoryPropType),
    imageSrc: PropTypes.string, // PropTypes.string.isRequired,
    author: AuthorPropType
});

export const FaqEntryPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
});
